import { useRef, useCallback } from 'react'

type Options = {
  onTrigger: () => void
  requiredCount?: number
  resetIntervalMs?: number
}

type Result = {
  onTap: () => void
}

/**
 * 短時間内に指定回数タップされると onTrigger を発火するカスタムフック。
 * 非表示の隠しコマンドとして使用することを想定しており、re-render を避けるため内部状態は ref で管理する。
 */
export const useHiddenTapGesture = ({ onTrigger, requiredCount = 10, resetIntervalMs = 800 }: Options): Result => {
  const countRef = useRef(0)
  const lastTapRef = useRef(0)

  const onTap = useCallback(() => {
    const now = Date.now()
    if (now - lastTapRef.current > resetIntervalMs) {
      countRef.current = 0
    }
    lastTapRef.current = now
    countRef.current += 1
    if (countRef.current >= requiredCount) {
      countRef.current = 0
      onTrigger()
    }
  }, [onTrigger, requiredCount, resetIntervalMs])

  return { onTap }
}
